<div class="dropdown" *transloco="let t">
	<!--  <div class="dropdown-header flex items-center justify-between">-->
	<!--    <div class="flex items-center">-->
	<!--      Options-->
	<!--    </div>-->
	<!--  </div>-->

	<div class="dropdown-content">
		<div class="row m-1">
			<button (click)="navigateToUserProfile()" mat-button type="button">
				<mat-icon [svgIcon]="icons.get('editUser')"></mat-icon>
				{{ t('userProfile.editUserProfile') }}
			</button>
		</div>
	</div>

	<div class="dropdown-footer flex items-center justify-between p-1">
		<!--    <a (click)="close()" color="accent" mat-button>{{ t('sideboard.logout') }}</a>-->
		<button mat-raised-button class="logout-button" color="accent" (click)="logout()">
			<mat-icon [svgIcon]="icons.get('logout')" class="mr-1"></mat-icon>
			{{ t('sideboard.logout') }}
		</button>
	</div>
</div>
